import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const en: TTranslations = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Learning',
    PAGE_SUBTITLE:
      'Track usage of the learning platform. Own courses vs Crehana catalog, quarterly trends, certifications and satisfaction.',
    NEW_TAG: 'New',
    FRESHNESS_PREFIX: 'Last updated:',
    PRODUCT_SELECTOR_LABEL: 'Product',
    PRODUCT_SELECTOR_HELPER: 'Select the product you want to analyze',
    PRODUCT_GENERAL: 'General',
    PRODUCT_LEARNING: 'Learning',
    BREADCRUMB_LEARNING: 'Learning',
    TAB_GENERAL: 'General',
    TAB_PATHS: 'By paths',
    TAB_COURSES: 'By courses',
    TAB_USERS: 'By users',
    TAB_PLACEHOLDER_PATHS: 'Paths content coming soon',
    TAB_PLACEHOLDER_COURSES: 'Courses content coming soon',
    TAB_PLACEHOLDER_USERS: 'Users content coming soon',
    EMPTY_TITLE: 'No modules available',
    EMPTY_DESCRIPTION: 'When learning data is available, you will see it here.',
    ERROR_TITLE: 'Error loading dashboard',
    ERROR_RETRY: 'Retry',
    PERIOD_LABEL: 'Period',
    PERIOD_WEEK: 'This week',
    PERIOD_MONTH: 'This month',
    PERIOD_QUARTER: 'This quarter',
    PERIOD_YEAR: 'This year',
    PERIOD_CUSTOM: 'Custom range',
    PERIOD_HINT:
      'Metrics and tables are recalculated based on the selected period',
    PERIOD_SELECT_ARIA: 'Select period',
    PERIOD_RANGE_PLACEHOLDER: 'Select a range',
    SEGMENT_BAR_LABEL: 'Segment by',
    SEGMENT_TRIGGER_PLACEHOLDER: 'Select an attribute',
    SEGMENT_SEARCH_PLACEHOLDER: 'Search attribute',
    SEGMENT_GROUP_DEFAULT: 'Default',
    SEGMENT_GROUP_CUSTOM: 'Custom',
    SEGMENT_MANAGE_ACTION: 'Manage attributes',
    SEGMENT_LOADING: 'Loading attributes…',
    SEGMENT_ERROR: 'We could not load attributes',
    SEGMENT_ERROR_RETRY: 'Retry',
    SEGMENT_EMPTY: 'No attributes available',
    SEGMENT_NO_RESULTS: 'No results',
    SEGMENT_SECTION_TITLE: 'Segmentation',
    SEGMENT_TAG_GRANULAR: 'Granular',
    SEGMENT_SECTION_DESC:
      'Regroup the metrics by any attribute of your company — the defaults from the collaborator base or the custom attributes you have configured.',
    CERT_SECTION_TITLE: 'Certificates',
    CERT_SECTION_DESC:
      'A certificate is issued when a user completes a course that has certification enabled. A single user can earn multiple certificates (one per completed course).',
    HISTORIC_CHIP: 'Historical · not period-dependent',
    CERT_KPI_TOTAL_LABEL: 'Certificates issued (Total)',
    CERT_DOWNLOAD_LINK_LABEL: 'Download certificates',
    CERT_KPI_USERS_LABEL: 'Users with at least 1 certificate',
    CERT_KPI_AVG_LABEL: 'Average certificates per user',
    CERT_CHART_TITLE: 'Certificates issued per month',
    CERT_CHART_HELPER: 'Last 16 months · Certificates issued per month',
    CERT_CHART_BARS_LEGEND: 'Certificates',
    CSAT_SECTION_TITLE: 'Survey Satisfaction — Key tracks',
    CSAT_TABLE_TITLE: 'Survey satisfaction by key track',
    CSAT_COL_ROUTE: 'Track',
    CSAT_COL_SCORE: 'CSAT (1–5)',
    CSAT_COL_SCORE_TOOLTIP:
      'Average CSAT of the courses in this track. Different from the individual course rating shown in the key metrics block.',
    CSAT_COL_RESPONSES: 'Responses',
    CSAT_COL_UNIQUE_USERS: 'Unique users',
    CSAT_SCORE_SUFFIX: '/5',
    CSAT_EMPTY_TITLE: 'No key tracks',
    CSAT_EMPTY_DESC: 'No tracks launched in the last 90 days.',
    CSAT_ERROR_TITLE: 'Failed to load CSAT data',
    CSAT_ERROR_RETRY: 'Retry',
    // === ANLT-273 Activity Trends Section ===
    TRENDS_TENDENCIAS_SECTION_TITLE: 'Trends',
    TRENDS_HISTORICO_CHIP: 'Historical · does not depend on the period',
    TRENDS_NOTE_INSCRIPCION: 'Grouped by enrollment date',
    TRENDS_NOTE_ACTIVOS: 'Includes only currently active collaborators',
    TRENDS_PROPIOS_CATALOGO_TITLE: 'Own Courses vs Crehana Catalog',
    TRENDS_PROPIOS_CATALOGO_HELPER:
      '**Own** = courses uploaded by the company · **Catalog** = courses from the Crehana library. Chart shows enrollments (registrations) and completions per quarter.',
    TRENDS_EVOLUCION_TITLE: 'Quarterly Evolution',
    TRENDS_EVOLUCION_HELPER:
      'Enrolled + Completed (bars) and % Completion (line)',
    TRENDS_MENSUAL_TITLE: 'Monthly Trend',
    TRENDS_MENSUAL_HELPER:
      'Last 15 months · Enrolled, Unique users and Completed',
    TRENDS_DETALLE_TITLE: 'Quarterly detail',
    TRENDS_DETALLE_HELPER: 'Same metrics, absolute values · 5 quarters',
    SERIES_PROPIO_ENR: 'Own - Enrolled',
    SERIES_CATALOGO_ENR: 'Catalog - Enrolled',
    SERIES_PROPIO_COMP: 'Own - Completed',
    SERIES_CATALOGO_COMP: 'Catalog - Completed',
    SERIES_ENROLLMENTS: 'Enrolled',
    SERIES_UNICOS: 'Unique users',
    SERIES_COMPLETADOS: 'Completed',
    SERIES_COMPLETION: '% Completion',
    TABLE_PERIODO: 'Period',
    TABLE_ENROLLMENTS: 'Enrolled',
    TABLE_COMPLETADOS: 'Completed',
    TABLE_CERTIFICADOS: 'Certificates',
    TABLE_USUARIOS_UNICOS: 'Unique users',
    TABLE_AVG_PROGRESS: 'Avg Progress',
    TABLE_COMPLETION: '% Completion',

    // ── ANLT-279 · Rankings ──────────────────────────────────────────────
    RANK_LEARNERS_TITLE: 'Top Learners',
    RANK_CURSOS_TITLE: 'Top Courses by Certificates',
    RANK_INACTIVOS_TITLE: 'Inactive users',
    RANK_INACTIVOS_CHIP: 'No access in 30+ days',

    RANK_COL_RANK: '#',
    RANK_COL_NAME: 'Name',
    RANK_COL_ENROLLMENTS: 'Enrollments',
    RANK_COL_COMPLETED: 'Completed',
    RANK_COL_CERTIFICATES: 'Certificates',
    RANK_COL_HOURS: 'Hours',
    RANK_COL_COURSE: 'Course',
    RANK_COL_TYPE: 'Type',
    RANK_COL_USERS: 'Users',
    RANK_COL_DEPARTMENT: 'Department',
    RANK_COL_LOCATION: 'Location',
    RANK_COL_LAST_ACTIVITY: 'Last activity',
    RANK_COL_PENDING: 'Pending courses',

    RANK_SOURCE_PROPIO: 'In-house',
    RANK_SOURCE_CATALOGO: 'Catalog',

    RANK_INACTIVOS_COUNT: '{{count}} collaborators',
    RANK_INACTIVOS_SUMMARY:
      'with no access in over 30 days · sorted by inactivity',
    RANK_LAST_ACTIVITY_RELATIVE: '{{count}} days ago',
    RANK_LAST_ACTIVITY_NEVER: 'Never logged in',
    RANK_INACTIVOS_NOTE: 'Reminders are managed from Internal Communications',
    RANK_INACTIVOS_LINK: 'View all {{count}} inactive users →',

    RANK_LEARNERS_EMPTY_TITLE: 'No learner data',
    RANK_LEARNERS_EMPTY_DESC: 'No learning activity in the selected period.',
    RANK_CURSOS_EMPTY_TITLE: 'No course data',
    RANK_CURSOS_EMPTY_DESC: 'No certificates issued in the selected period.',
    RANK_INACTIVOS_EMPTY_TITLE: 'No inactive users',
    RANK_INACTIVOS_EMPTY_DESC:
      'No users without access in the last 30 days. All active!',
    RANK_ERROR_TITLE: 'Error loading the ranking',
    RANK_ERROR_RETRY: 'Retry',
    // ANLT-275 — Learning Paths (table)
    // ── ANLT-275 · Learning Paths ─────────────────────────────────────────
    LP_SECTION_HEADING: 'Learning Paths',
    LP_FILTER_TIPO_LABEL: 'Type:',
    LP_FILTER_TIPO_ALL: 'All',
    LP_FILTER_TIPO_MANDATORY: 'Mandatory',
    LP_FILTER_TIPO_OPTIONAL: 'Optional',
    LP_FILTER_ORIGEN_LABEL: 'Source:',
    LP_FILTER_ORIGEN_ALL: 'All',
    LP_FILTER_ORIGEN_OWN: 'Own',
    LP_FILTER_ORIGEN_CATALOG: 'Catalog',
    LP_COL_PATH: 'Path',
    LP_COL_ENROLLED: 'Enrolled',
    LP_COL_COURSES_COMPLETED: 'Courses completed',
    LP_COL_PATH_COMPLETED: 'Path completed',
    LP_COL_COURSES_REQUIRED: 'Req. courses',
    LP_COL_COMPLETION: '% Completion',
    LP_TABLE_EMPTY_TITLE: 'No path data',
    LP_TABLE_EMPTY_DESC:
      'No learning paths were found for the selected period.',
    LP_TABLE_ERROR_RETRY: 'Retry',
    // ── ANLT-271: KPI section — Key metrics ──────────────────────────────────
    // ── ANLT-271 · KPI Section — Key metrics ─────────────────────────────
    KPI_SECTION_HEADING: 'Key metrics',
    KPI_SPARKLINE_A11Y: 'Trend',
    KPI_ENGAGED_LABEL: 'Engaged Learning collaborators',
    KPI_ENGAGED_HELP:
      'Collaborators with activity in courses or paths in the last 30 days, over total collaborators. Measures how active the platform is.',
    KPI_ENROLLMENTS_LABEL: 'Enrollments',
    KPI_ENROLLMENTS_HELP:
      'Total course enrollments accumulated year-to-date (YTD). Includes own catalog and Crehana catalog.',
    KPI_COMPLETIONS_LABEL: 'Completions',
    KPI_COMPLETIONS_HELP:
      'Courses finished at 100% of viewing. Completion rate compares completed vs. started.',
    KPI_COMPLETED_HOURS_LABEL: 'Completed hours',
    KPI_COMPLETED_HOURS_HELP:
      'Accumulated playback hours (progress × duration, homogenized bioprogress source). SCORM/external content does not record playback.',
    KPI_CERTIFICATES_LABEL: 'Certificates issued',
    KPI_CERTIFICATES_DOWNLOAD_ACTION_TOOLTIP: 'Download certificates',
    KPI_CERTIFICATES_HELP:
      'Certificates generated upon completing a course with certification enabled.',
    KPI_CSAT_LABEL: 'Average CSAT',
    KPI_CSAT_HELP:
      'Average satisfaction (1–5) from end-of-course surveys answered in the period.',
    KPI_INACTIVE_LABEL: 'Inactive users (>30 days)',
    KPI_INACTIVE_HELP:
      'Active users with no platform access in the last 30 days. Reactivation candidates. The 30-day threshold is fixed and does not depend on the selected period.',
    KPI_VS_PREV_PERIOD: 'vs previous period',
    KPI_COMPLETION_RATE_SUFFIX: 'completion rate',
    KPI_SECTION_EMPTY_TITLE: 'No learning data',
    KPI_SECTION_EMPTY_DESCRIPTION:
      'When metrics are available, you will see them here.',
    KPI_SECTION_ERROR_RETRY: 'Retry',
    KPI_ENGAGED_FOOTER: 'Active in courses/paths · Source: Learning events',
    KPI_ENROLLMENTS_FOOTER: 'Accumulated enrollments',
    KPI_COMPLETIONS_FOOTER: 'Courses finished at 100%',
    KPI_COMPLETED_HOURS_FOOTER:
      'Progress × duration · Source: homogenized bioprogress',
    KPI_CERTIFICATES_FOOTER: 'Courses with certification enabled',
    KPI_CSAT_FOOTER: 'Post-course surveys',
    KPI_INACTIVE_FOOTER: 'No access in 30+ days',
    KPI_INACTIVE_LINK_LABEL: 'View list',
    // Rich sublabels for KPIs that expose numerator/denominator (ANLT-271/272)
    KPI_ENGAGED_SUBLABEL_PREFIX: 'de {{denominator}} colaboradores',
    KPI_ENGAGED_SUBLABEL_HIGHLIGHT: 'engagement',
    KPI_HOURS_SUBLABEL_SUFFIX: 'avg · per active collaborator',
    KPI_CSAT_SUBLABEL_SUFFIX: 'responses',
    KPI_INACTIVE_SUBLABEL_SUFFIX: 'de {{denominator}} colaboradores',
    // Crehana AI inline CTA (ANLT-369) — footer of each of the 4 tabs
    AI_CTA_BADGE: 'Crehana AI',
    AI_CTA_TITLE: 'Want to ask a specific question?',
    AI_CTA_DESCRIPTION:
      'Ask Crehana AI about this data — completion, study hours, inactive users, segmentation by area and more.',
    AI_CTA_BUTTON: 'Ask Crehana AI',
    // ── Tab "By users" — KPI band (ANLT-296) ──────────────────────────────────
    USERS_KPI_SECTION_HEADING: 'User metrics',
    USERS_KPI_SECTION_ERROR_RETRY: 'Retry',
    USERS_ACTIVE_ONLY_BANNER:
      'The table statistics include all collaborators in the report; the "Active users" band counts only those active during the period. Near real-time data.',
    USERS_KPI_ACTIVE_LABEL: 'Active users',
    USERS_KPI_ACTIVE_HELP: 'Users with an active status on the platform.',
    USERS_KPI_STUDYING_LABEL: 'Studying users',
    USERS_KPI_STUDYING_HELP:
      'Users with at least one course started in the period. A subset of active users.',
    USERS_KPI_STUDYING_FOOTER: 'with ≥1 course started · {{period}}',
    USERS_KPI_HOURS_LABEL: 'Average hours / user',
    USERS_KPI_HOURS_HELP:
      'Study hours in the period divided by active users. Source: bioprogress (progress × duration).',
    USERS_KPI_CERTIFICATE_LABEL: 'Users with ≥1 certificate',
    USERS_KPI_CERTIFICATE_HELP:
      'Active users who earned at least one certificate.',
    // ── Tab "By users" — Segmentation / breakdown (ANLT-296) ──────────────────
    USERS_KPI_CERTIFICATE_FOOTER: '{{num}} of {{den}} active users',
    USERS_SORT_LABEL: 'Sort by',
    USERS_SORT_HOURS: 'Study hours',
    USERS_SORT_CERTIFICATES: 'Certificates',
    USERS_BREAKDOWN_HEADING: 'Segmentation',
    USERS_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    USERS_BREAKDOWN_DESC:
      'Regroup metrics by any attribute of your company — the defaults from the employee base or the custom attributes you have configured.',
    USERS_BREAKDOWN_CAPTION: '{{active}} active · {{studying}} studying',
    USERS_SEGMENT_FILTER_CHIP: 'Segment: {{segment}}',
    // Shared prefix rendered to the LEFT of the active segment-filter chip on the
    // rutas/cursos/usuarios tables (ANLT-440): "Filtered by: [chip]".
    SEGMENT_FILTER_PREFIX: 'Filtered by:',
    USERS_BREAKDOWN_EMPTY:
      'When per-segment data is available, you will see it here.',
    USERS_BREAKDOWN_ERROR: 'We could not load the user segmentation.',
    USERS_BREAKDOWN_ERROR_RETRY: 'Retry',
    // ── Tab "By routes" — Segmentation / medallero (ANLT-395) ──────────────────
    ROUTES_SORT_LABEL: 'Sort by',
    ROUTES_SORT_COMPLETITUD: 'Completion',
    ROUTES_SORT_ROUTES_COMPLETED: '% routes completed',
    ROUTES_SORT_COURSES_COMPLETED: '% courses completed',
    ROUTES_SORT_EVALUATIONS: '% evaluations',
    ROUTES_SORT_PROJECTS: '% projects',
    ROUTES_SORT_USERS: 'Users',
    ROUTES_BREAKDOWN_HEADING: 'Segmentation',
    ROUTES_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    ROUTES_BREAKDOWN_DESC:
      'Regroup route metrics by any attribute of your company — the defaults from the employee base or the custom attributes you have configured. The per-segment user cohort is the active cohort, so it will not sum 1:1 against the overall band.',
    ROUTES_BREAKDOWN_CAPTION: '{{users}} users',
    ROUTES_BREAKDOWN_EMPTY:
      'When per-segment data is available, you will see it here.',
    ROUTES_BREAKDOWN_ERROR: 'We could not load the route segmentation.',
    ROUTES_BREAKDOWN_ERROR_RETRY: 'Retry',
    // ── Tab "By users" — Users table / drawer (ANLT-298) ───────────────────────
    USERS_TABLE_HEADING: 'Users',
    USERS_TABLE_COUNT_LABEL: 'Users',
    USERS_TABLE_COL_USER: 'User',
    USERS_TABLE_COL_AREA: 'Area',
    USERS_TABLE_COL_COURSES: 'Enrolled courses',
    USERS_TABLE_TOOLTIP_COURSES:
      'Counts enrollments created within the selected period. It is not an all-time total.',
    USERS_TABLE_COL_ASSIGNED: 'Assigned',
    USERS_TABLE_COL_COMPLETED: 'Completed',
    USERS_TABLE_COL_PROGRESS: '% Progress',
    USERS_TABLE_COL_ROUTES: 'Routes',
    USERS_TABLE_COL_CERTIFICATES: 'Certif.',
    USERS_TABLE_COL_HOURS: 'Hours',
    USERS_TABLE_COL_LAST_ACTIVITY: 'Last activity',
    USERS_TABLE_HOURS_VALUE: '{{hours}}h',
    USERS_TABLE_ACTIVITY_TODAY: 'Today',
    USERS_TABLE_ACTIVITY_YESTERDAY: 'Yesterday',
    USERS_TABLE_ACTIVITY_DAYS_AGO: '{{count}} days ago',
    USERS_TABLE_SEARCH_PLACEHOLDER: 'Enter user name',
    USERS_TABLE_EMPTY: 'When user data is available, you will see it here.',
    USERS_TABLE_NO_RESULTS: 'No users match your search.',
    USERS_TABLE_NEVER_LOGGED: 'Never logged in',
    USER_DETAIL_CLOSE: 'Close',
    USER_DETAIL_KPI_COMPLETED: 'Completed courses',
    USER_DETAIL_KPI_ROUTES: 'Completed routes',
    USER_DETAIL_KPI_CERTIFICATES: 'Certificates',
    USER_DETAIL_KPI_HOURS: 'Study hours',
    USER_DETAIL_ROUTES_TITLE: 'Routes in progress',
    USER_DETAIL_ACTIVITY_TITLE: 'Recent activity',
    USER_DETAIL_ACTIVITY_COMPLETED: 'Completed',
    USER_DETAIL_ACTIVITY_IN_PROGRESS: 'In progress · {{progress}}%',
    USER_DETAIL_ROUTE_COURSES_FRACTION: '{{completed}} of {{assigned}} courses',
    USER_DETAIL_VIEW_PROFILE: 'View full profile',
    USER_DETAIL_EMPTY: 'This user has no data to show yet.',
    USERS_TABLE_EXPORT_REPORT: 'Export report',
    USERS_REPORT_GENERATION_SUCCESS: 'Report generated successfully.',
    USERS_REPORT_GENERATION_SUCCESS_DESC:
      'You will find this report in the Reports section.',
    USERS_REPORT_GENERATION_PENDING:
      'There is already a report being generated',
    USERS_REPORT_GENERATION_ERROR: 'Report could not be generated',
    USERS_REPORT_GENERATION_ERROR_DESC:
      'There was a problem generating your report. Please try again.',
    USERS_REPORT_PERMISSION_ERROR_TITLE:
      'You do not have permission to perform this action',
    USERS_REPORT_PERMISSION_ERROR_DESC:
      'Your role or organization does not allow generating this report. Contact your admin if you think this is a mistake.',
    USERS_REPORT_RATE_LIMIT_TITLE: 'Maximum attempts per minute',
    USERS_REPORT_RATE_LIMIT_DESC:
      'You have reached the report generation limit per minute. Please wait a few minutes before trying again.',
    // Courses KPI band (ANLT-292/293) — active-only metrics
    COURSES_KPI_SECTION_HEADING: 'Course metrics',
    COURSES_KPI_BANNER:
      'Here you will find all the courses you have assigned within paths or as **free courses** to your users — own catalog and Crehana catalog.',
    COURSES_KPI_CATALOG_LABEL: 'Catalog:',
    COURSES_KPI_CATALOG_ALL: 'All',
    COURSES_KPI_CATALOG_OWN: 'Own',
    COURSES_KPI_CATALOG_CREHANA: 'Crehana',
    COURSES_KPI_ACTIVE_LABEL: 'Active courses',
    COURSES_KPI_ACTIVE_HELP:
      'Courses currently assigned to users, within paths or as free courses. Includes own and Crehana catalog.',
    COURSES_KPI_ACTIVE_FOOTER: '{{own}} own · {{catalog}} from Crehana catalog',
    COURSES_KPI_ENROLLMENTS_LABEL: 'Enrollments',
    COURSES_KPI_ENROLLMENTS_HELP:
      'Total course enrollments accumulated year to date (YTD).',
    COURSES_KPI_ENROLLMENTS_FOOTER: 'accumulated · {{period}}',
    COURSES_KPI_COMPLETED_LABEL: 'Completed',
    COURSES_KPI_COMPLETED_HELP:
      'Courses finished at 100% viewing year to date.',
    COURSES_KPI_COMPLETED_FOOTER: 'finished · {{period}}',
    COURSES_KPI_COMPLETION_RATE_LABEL: 'Completion rate',
    COURSES_KPI_COMPLETION_RATE_HELP:
      'Average of completed courses over started courses. Measures the share of learners who finish what they start.',
    COURSES_KPI_COMPLETION_RATE_FOOTER: 'average over started courses',
    COURSES_KPI_EMPTY_TITLE: 'No course data available',
    COURSES_KPI_EMPTY_DESCRIPTION:
      'When metrics are available, you will see them here.',
    COURSES_KPI_ERROR_RETRY: 'Retry',
    // ── ANLT-294 round-4: Courses medallero + search ──────────────────────────
    COURSES_SORT_LABEL: 'Sort by',
    COURSES_SORT_ENROLLMENTS: 'Enrollments',
    COURSES_SORT_COMPLETED: 'Completed',
    COURSES_SORT_COMPLETION_RATE: 'Completion rate',
    COURSES_BREAKDOWN_HEADING: 'Segmentation',
    COURSES_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    COURSES_BREAKDOWN_DESC:
      'Regroup course metrics by any attribute of your company — the defaults from the employee base or the custom attributes you have configured.',
    COURSES_BREAKDOWN_CAPTION: '{{active}} active · {{started}} started',
    COURSES_BREAKDOWN_EMPTY:
      'When per-segment data is available, you will see it here.',
    COURSES_BREAKDOWN_ERROR: 'We could not load the course segmentation.',
    COURSES_BREAKDOWN_ERROR_RETRY: 'Retry',
    COURSES_TABLE_SEARCH_PLACEHOLDER: 'Search course',
    COURSES_TABLE_NO_RESULTS_TITLE: 'No results',
    COURSES_TABLE_NO_RESULTS_DESCRIPTION:
      'We could not find any courses matching your search.',
    // Courses table + drawer (ANLT-294)
    COURSES_TABLE_SECTION_HEADING: 'Course details',
    COURSES_TABLE_TITLE: 'Courses',
    COURSES_SEGMENT_FILTER_CHIP: 'Segment: {{segment}}',
    COURSES_TABLE_COL_COURSE: 'Course',
    COURSES_TABLE_COL_TYPE: 'Type',
    COURSES_TABLE_COL_ENROLLED: 'Enrolled',
    COURSES_TABLE_COL_STARTED: 'Started',
    COURSES_TABLE_COL_COMPLETED: 'Completed',
    COURSES_TABLE_COL_EVAL_APPROVED: 'Eval. passed',
    COURSES_TABLE_COL_PROGRESS: '% Progress',
    COURSES_TABLE_COL_REPRODUCTION_HOURS: 'Playback hours',
    COURSES_TABLE_COL_CERTIFICATES: 'Certificates',
    COURSES_TABLE_COL_CSAT: 'CSAT',
    COURSES_TABLE_TOOLTIP_ENROLLED:
      'Counts enrollments (a user may have more than one), matching the Courses report.',
    COURSES_TABLE_TOOLTIP_EVAL_APPROVED:
      'Percentage of approved evaluations over total evaluations taken.',
    COURSES_TABLE_TOOLTIP_REPRODUCTION_HOURS:
      'Total video hours played by users enrolled in the course.',
    COURSES_TABLE_TOOLTIP_CSAT:
      'Average satisfaction reported by users who answered the post-course survey.',
    COURSES_TABLE_CSAT_EMPTY: 'No data',
    COURSES_TABLE_EMPTY_TITLE: 'No courses for this period',
    COURSES_TABLE_EMPTY_DESCRIPTION:
      "We couldn't find courses matching the selected period.",
    COURSES_TABLE_ERROR_TITLE: "We couldn't load the table",
    COURSES_TABLE_ERROR_DESCRIPTION:
      'An error occurred while fetching courses. Please retry.',
    COURSES_TABLE_ERROR_RETRY: 'Retry',
    // ── ANLT-294 round-3: "Export report" (REPORT_B2B_COURSES) ────────────────
    COURSES_TABLE_EXPORT_ACTION: 'Export report',
    COURSES_TABLE_EXPORT_STARTED_TITLE:
      'Generating report... this may take a few minutes',
    COURSES_TABLE_EXPORT_STARTED_DESC:
      'You will find this report in the Reports section when it finishes.',
    COURSES_TABLE_EXPORT_PENDING: 'There is already a report being generated',
    COURSES_TABLE_EXPORT_ERROR_TITLE: 'We could not generate the report',
    COURSES_TABLE_EXPORT_ERROR_DESC:
      'There was a problem generating your report. Please try again.',
    COURSES_TABLE_EXPORT_PERMISSION_TITLE:
      'You do not have permission to perform this action',
    COURSES_TABLE_EXPORT_PERMISSION_DESC:
      'Your role or organization does not allow generating this report. Contact your admin if you think this is a mistake.',
    COURSES_TABLE_EXPORT_RATE_LIMIT_TITLE: 'Maximum attempts per minute',
    COURSES_TABLE_EXPORT_RATE_LIMIT_DESC:
      'You have reached the report generation limit per minute. Please wait a few minutes before trying again.',
    COURSES_TABLE_SOURCE_OWN: 'Own',
    COURSES_TABLE_SOURCE_CATALOG: 'Catalog',
    COURSES_TABLE_DRAWER_PERFORMANCE_HEADING: 'Course performance',
    COURSES_TABLE_DRAWER_SATISFACTION_HEADING: 'Satisfaction',
    COURSES_TABLE_DRAWER_TOP_USERS_HEADING: 'Top users',
    COURSES_TABLE_DRAWER_CSAT_RESPONSES: 'Based on {{count}} responses',
    COURSES_TABLE_DRAWER_CSAT_AVERAGE: 'Average CSAT',
    COURSES_TABLE_DRAWER_CLOSE: 'Close',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_USER: 'User',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_PROGRESS: '% Progress',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_POSITION: 'Position',
    COURSES_TABLE_DRAWER_TOP_USERS_SEARCH: 'Search user',
    COURSES_TABLE_DRAWER_VIEW_PROFILE: 'View full profile',
    COURSES_TABLE_DRAWER_KPI_ENROLLED_LABEL: 'Enrolled',
    COURSES_TABLE_DRAWER_KPI_COMPLETED_LABEL: 'Completed',
    COURSES_TABLE_DRAWER_KPI_COMPLETION_RATE_LABEL: 'Completion rate',
    COURSES_TABLE_DRAWER_KPI_REPRODUCTION_HOURS_LABEL: 'Playback hours',
    COURSES_TABLE_DRAWER_ERROR: "We couldn't load the course detail.",
    // ── ANLT-288: Routes KPI section — Current route status ──────────────────
    ROUTES_KPI_SECTION_HEADING: 'Total route progress',
    ROUTES_KPI_SECTION_ERROR_RETRY: 'Retry',
    ROUTES_KPI_COMPLETITUD_TOTAL_LABEL: 'Total completion',
    ROUTES_KPI_COMPLETITUD_TOTAL_HELP:
      'Average progress percentage across all routes assigned to collaborators.',
    ROUTES_KPI_COMPLETITUD_TOTAL_FOOTER: 'Average route progress',
    ROUTES_KPI_ROUTES_COMPLETED_LABEL: 'Routes completed',
    ROUTES_KPI_ROUTES_COMPLETED_HELP:
      'Percentage of assigned routes completed at 100% by collaborators.',
    ROUTES_KPI_ROUTES_COMPLETED_FOOTER: 'Routes at 100% progress',
    ROUTES_KPI_COURSES_COMPLETED_LABEL: 'Courses completed',
    ROUTES_KPI_COURSES_COMPLETED_HELP:
      'Percentage of courses within routes completed at 100% by collaborators.',
    ROUTES_KPI_COURSES_COMPLETED_FOOTER: 'Courses finished within routes',
    ROUTES_KPI_EVALUATIONS_APPROVED_LABEL: 'Evaluations approved',
    ROUTES_KPI_EVALUATIONS_APPROVED_HELP:
      'Percentage of route evaluations approved out of all evaluations taken.',
    ROUTES_KPI_EVALUATIONS_APPROVED_FOOTER:
      'Evaluations approved within routes',
    ROUTES_KPI_PROJECTS_APPROVED_LABEL: 'Projects approved',
    ROUTES_KPI_PROJECTS_APPROVED_HELP:
      'Percentage of route projects approved out of all projects submitted.',
    ROUTES_KPI_PROJECTS_APPROVED_FOOTER: 'Projects approved within routes',
    // ── ANLT-290: Routes deep-dive table columns ──────────────────────────────
    RDD_COL_ROUTE: 'Route',
    RDD_COL_ENROLLED: 'Enrolled',
    RDD_COL_COMPLETION: 'Progress',
    RDD_COL_COURSES_REQUIRED: 'Req. courses',
    RDD_COL_ROUTE_COMPLETED: 'Route completed',
    RDD_COL_EVALUATIONS: 'Evaluations',
    RDD_COL_PROJECTS: 'Projects',
    RDD_COL_CSAT: 'CSAT',
    RDD_COL_STATUS: 'Status',
    RDD_CSAT_NO_DATA: 'No data',
    RDD_STATUS_ACTIVE: 'Active',
    RDD_STATUS_ARCHIVED: 'Archived',
    RDD_STATUS_EMPTY: 'No enrollments',
    // ── ANLT-290: Route detail drawer ──────────────────────────────────────────
    RDD_DRAWER_TITLE: 'Route detail',
    RDD_DRAWER_SUBTITLE:
      '{{courses}} courses · {{evaluations}} evaluations · {{projects}} projects',
    RDD_DRAWER_CLOSE: 'Close',
    RDD_DRAWER_ERROR_RETRY: 'Retry',
    RDD_DRAWER_COMPLETION_TITLE: 'Route completion',
    RDD_DRAWER_KPI_ENROLLED: 'Enrolled users',
    RDD_DRAWER_KPI_AVG_PROGRESS: 'Average progress',
    RDD_DRAWER_KPI_COURSES_REQUIRED: 'Required courses',
    RDD_DRAWER_KPI_EVALUATIONS: 'Evaluations',
    RDD_DRAWER_KPI_PROJECTS: 'Projects',
    RDD_DRAWER_COURSES_TITLE: 'Courses in the route',
    RDD_DRAWER_COURSES_COMPLETED: '{{count}} completed',
    RDD_DRAWER_TOP_USERS_TITLE: 'Top users in the route',
    RDD_DRAWER_TOP_USERS_COL_POSITION: 'Position',
    RDD_DRAWER_TOP_USERS_COL_USER: 'User',
    RDD_DRAWER_TOP_USERS_COL_PROGRESS: '% Progress',
    RDD_DRAWER_TOP_USERS_SEARCH: 'Search user',
    RDD_DRAWER_VIEW_PROFILE: 'View full profile',
    RDD_DRAWER_EMPTY: 'No information to show.',
    // ── ANLT-290: Routes deep-dive section shell ──────────────────────────────
    RDD_SECTION_HEADING: 'Routes breakdown',
    RDD_TABLE_TITLE: 'Routes',
    RDD_EMPTY_TITLE: 'No route data yet',
    RDD_EMPTY_DESC: "We couldn't find routes for the selected period.",
    RDD_ERROR_RETRY: 'Retry',
    // ── ANLT-290 round-3: search + export ─────────────────────────────────────
    RDD_TABLE_SEARCH_PLACEHOLDER: 'Search route',
    RDD_TABLE_NO_RESULTS: 'No route matches your search.',
    RDD_SEGMENT_FILTER_CHIP: 'Segment: {{segment}}',
    RDD_EXPORT_BUTTON: 'Export report',
    RDD_EXPORT_STARTED_TITLE: "We're generating your report",
    RDD_EXPORT_STARTED_DESC:
      "You'll be able to download it from the Reports section in a few minutes.",
    RDD_EXPORT_PENDING: 'A report is already being generated.',
    RDD_EXPORT_ERROR_TITLE: "We couldn't generate your report",
    RDD_EXPORT_ERROR_DESC: 'Please try again in a few minutes.',
    RDD_EXPORT_RATE_LIMIT_TITLE: 'Maximum attempts per minute',
    RDD_EXPORT_RATE_LIMIT_DESC: 'Please wait a moment before trying again.',
    RDD_EXPORT_PERMISSION_TITLE: "You don't have permission to do this",
    RDD_EXPORT_PERMISSION_DESC:
      'Contact an administrator if you think this is a mistake.',
    // ── ANLT-466 · Study hours (heatmap) ───────────────────────────────────
    STUDY_HOURS_CARD_TITLE: 'Study hours',
    STUDY_HOURS_CARD_DESCRIPTION:
      "Your organization's study activity by week, month and year.",
    STUDY_HOURS_TAB_WEEKLY: 'Weekly',
    STUDY_HOURS_TAB_MONTHLY: 'Monthly',
    STUDY_HOURS_TAB_YEARLY: 'Yearly',
    STUDY_HOURS_TAB_WEEKLY_AXIS_LEFT: 'Day',
    STUDY_HOURS_TAB_WEEKLY_AXIS_TOP: 'Hour',
    STUDY_HOURS_TAB_MONTHLY_AXIS_LEFT: 'Weeks of the month',
    STUDY_HOURS_TAB_MONTHLY_AXIS_LEFT_TOOLTIP: 'Week of the month',
    STUDY_HOURS_TAB_MONTHLY_AXIS_TOP: 'Months of the year',
    STUDY_HOURS_TAB_YEARLY_AXIS_LEFT: 'Year',
    STUDY_HOURS_TAB_YEARLY_AXIS_TOP: 'Month',
    STUDY_HOURS_INSIGHT_DAY:
      '{{moment}} is your day with the most activity, with {{hours}} study hours',
    STUDY_HOURS_INSIGHT_MONTH:
      '{{moment}} was your month with the most activity, with {{hours}} study hours',
    STUDY_HOURS_INSIGHT_YEAR:
      '{{moment}} was your year with the most activity, with {{hours}} study hours',
    STUDY_HOURS_INSIGHT_EMPTY: 'Not enough activity yet to show an insight',
    STUDY_HOURS_KPI_TOTAL_LABEL: 'Total study hours',
    STUDY_HOURS_KPI_TOTAL_TOOLTIP:
      "Sum of your organization's playback hours in the selected period.",
    STUDY_HOURS_KPI_AVG_LABEL: 'Average hours per student',
    STUDY_HOURS_KPI_AVG_TOOLTIP:
      'Playback hours divided by students with activity in the selected period.',
    STUDY_HOURS_KPI_VS_WEEK: 'vs previous week',
    STUDY_HOURS_KPI_VS_MONTH: 'vs previous month',
    STUDY_HOURS_KPI_VS_YEAR: 'vs previous year',
    STUDY_HOURS_LEGEND_1: 'No activity',
    STUDY_HOURS_LEGEND_2: 'Low',
    STUDY_HOURS_LEGEND_3: 'Medium',
    STUDY_HOURS_LEGEND_4: 'High',
    STUDY_HOURS_LEGEND_TOOLTIP:
      'Color intensity indicates how many study hours happened in that cell.',
    STUDY_HOURS_CELL_TOOLTIP_LABEL: 'Study hours:',
    STUDY_HOURS_EMPTY_TITLE: 'No study activity',
    STUDY_HOURS_EMPTY_DESCRIPTION:
      'No study hours recorded in the selected period.',
    STUDY_HOURS_ERROR_RETRY: 'Retry',
  },
};
